import { Injectable, isDevMode } from '@angular/core';
import { ActivitiesDaoService } from 'src/app/dao/activities-dao-services/activities-dao.service';
import { Observable } from 'rxjs/internal/Observable';
import { UserStorageService } from '../user-storage-service/user-storage.service';
import { SmsStatistic } from 'src/app/models/activities-model/sms-statistic.model';
import { Subject } from 'rxjs/internal/Subject';
import { UserService } from '../user-service/user.service';
import { map, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {

  accessToken = 'ACT';
  private smsConsumptionSearchListener = new Subject<any>();
  private smsConsumptionRefreshListener = new Subject<any>();

  constructor(private activityDaoService: ActivitiesDaoService,
              private userService: UserService,
              private userStorageService: UserStorageService) { }

  public getSmsConsumptionList(datetimeFrom, datetimeTo) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.activityDaoService.getSmsConsumptionList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimeFrom, datetimeTo).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const smsStatistics = new Array<SmsStatistic>();
          o['data']['smsStatisticsList'].forEach(ss => {
            const smsStatistic = new SmsStatistic();
            Object.assign(smsStatistic, ss);
            smsStatistics.push(smsStatistic);
          });
          return smsStatistics;
        })
      );
    }
    return EMPTY;
  }

  public listenSmsConsumptionSearch() {
    return this.smsConsumptionSearchListener.asObservable();
  }

  public smsConsumptionSearch(dateFrom, dateTo) {
    this.smsConsumptionSearchListener.next({ dateFrom, dateTo });
  }

  public listenSmsConsumptionRefresh() {
    return this.smsConsumptionRefreshListener.asObservable();
  }

  public smsConsumptionRefresh(data) {
    this.smsConsumptionRefreshListener.next(data);
  }
}
